import gql from 'graphql-tag';

export default gql`
mutation UpdateOutput(
        $uuidApp: String!,
        $uuidEndpoint: String!,
        $idRequest: String!
        ) {
    updateOutput(
        uuidApp: $uuidApp,
        uuidEndpoint: $uuidEndpoint,
        idRequest: $idRequest
    ) {
        output
        error
        errorMessage
    }
  }
`;
